import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";

import { Dialog, DialogContent } from "../../../components/Dialog";
import { ConnectSeRankingModal } from "../metrics/ConnectSeRankingModal";
import { SeoProjectSetupModal } from "./SeoProjectSetupModal";
import { useSeRankingAvailableSites } from "./hooks";

// Edits a Markezy-created project; otherwise picks one from the sub-account (or creates
// it), or goes straight to the stepper when there is no sub-account.
export function SeoConnectModal(props) {
  const { open, onOpenChange, clientId, currentLink } = props;
  const [creating, setCreating] = useState(false);
  const needsSites = open && !currentLink;
  const sitesQuery = useSeRankingAvailableSites(clientId, { enabled: needsSites });

  useEffect(() => {
    if (!open) setCreating(false);
  }, [open]);

  if (!open) return null;

  if (currentLink?.managed) return <SeoProjectSetupModal {...props} editLink={currentLink} />;
  // A picked project is replaced or unlinked from the picker; creating would hit `linked_project`.
  if (currentLink) return <ConnectSeRankingModal {...props} />;

  if (sitesQuery.isLoading) {
    return (
      <Dialog open onOpenChange={onOpenChange} disableBackdropClose>
        <DialogContent>
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress size={24} />
          </Box>
        </DialogContent>
      </Dialog>
    );
  }

  if (sitesQuery.data?.connected && !creating) {
    return <ConnectSeRankingModal {...props} onCreateProject={() => setCreating(true)} />;
  }

  return <SeoProjectSetupModal {...props} />;
}

SeoConnectModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  clientId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  client: PropTypes.object,
  currentLink: PropTypes.object,
  onConnected: PropTypes.func,
  onDisconnected: PropTypes.func,
};

export default SeoConnectModal;
